import bannerSymbols from "../symbols/banners";

const initialState = {
  data: [],
  loading: false,
  error: false,
};

export default function BannerSymbolsReducer(
  state = initialState,
  action: any
) {
  switch (action.type) {
    case bannerSymbols.GET_BANNERS:
      return { ...state, loading: true, error: false };
    case bannerSymbols.GET_BANNERS_SUCCESS:
      return {
        ...state,
        data: action.payload.Result,
        loading: false,
        error: false,
      };
    case bannerSymbols.GET_BANNERS_FAILURE:
      return {
        ...state,
        data: [],
        loading: false,
        error: true,
      };
    case bannerSymbols.CLEAR_GET_BANNERS:
      return {
        ...state,
        data: [],
        loading: false,
        error: false,
      };

    default:
      return state;
  }
}
